import React from 'react';
import { Section } from '../ui/Section';
import { CheckCircle } from 'lucide-react';
export function ExpertBacking() {
  return <Section background="cream" data-id="element-4">
      <div className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-[#5EEAD4]/20 flex flex-col md:flex-row items-center gap-8" data-id="element-5">
        <div className="w-32 h-32 md:w-40 md:h-40 bg-gray-200 rounded-full flex-shrink-0 overflow-hidden border-4 border-[#F0FDFA]" data-id="element-6">
          {/* Placeholder for expert image - using a generic professional woman avatar */}
          <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Nutricionista Experta" className="w-full h-full object-cover" data-id="element-7" />
        </div>

        <div className="flex-1 text-center md:text-left" data-id="element-8">
          <h3 className="text-2xl font-serif font-bold text-[#4A3B32] mb-2" data-id="element-9">
            Respaldado por la Ciencia
          </h3>
          <div className="flex items-center justify-center md:justify-start mb-4" data-id="element-10">
            <span className="bg-[#CCFBF1] text-[#14B8A6] text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-11">
              Nutrición Funcional
            </span>
          </div>
          <p className="text-[#5D5D5D] italic mb-4" data-id="element-12">
            "La mayoría de las mujeres atacan la hinchazón con dietas
            restrictivas que solo aumentan el cortisol. Este método aborda la
            inflamación desde el sistema nervioso y la digestión mecánica, que
            es la verdadera causa en el 90% de los casos de estrés laboral."
          </p>
          <div className="flex items-center justify-center md:justify-start text-sm font-medium text-[#4A3B32]" data-id="element-13">
            <CheckCircle size={16} className="text-[#14B8A6] mr-2" data-id="element-14" />
            <span data-id="element-15">Dra. Elena S. - Especialista en Salud Digestiva</span>
          </div>
        </div>
      </div>
    </Section>;
}